import { makeStyles } from "makeStyles"
import YouTube from "react-youtube"

const useStyles = makeStyles()({
	videoWrapper: {
		position: "relative",
		paddingBottom: "56.25%",
		paddingTop: "25px",
		height: 0,
		marginBottom: "3rem",
		boxShadow: " 0px 0px 10px 0px rgba(0,0,0,0.3)",

		"& iframe": {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
		},
	},
})

const opts = {
	height: "560",
	width: "315",
	playerVars: {
		// https://developers.google.com/youtube/player_parameters
		autoplay: 0,
		controls: 0,
		showinfo: 0,
		fs: 1,
	},
}

const YoutubeVideo = ({ videoId, ...props }: Props) => {
	const { classes } = useStyles()

	return (
		<div {...props}>
			<div className={classes.videoWrapper}>
				<YouTube videoId={videoId} opts={opts} />
			</div>
		</div>
	)
}

interface Props {
	videoId: string
	className?: string
}

export default YoutubeVideo
